import React from 'react';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Meta from '@bizapp-lp/workflow/organisms/Meta';
import SimpleMarketoForm, {
  SimpleMarketoFormProps,
} from '@bizapp-lp/workflow/templates/SimpleMarketoForm';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    lineBreaks: {
      display: 'block',
    },
  }),
);

export interface ContactProps
  extends Pick<SimpleMarketoFormProps, 'marketoForm'> {
  grecaptchaKey?: string;
}

const title =
  'Workflow お問い合わせ | ノーコードで現場で簡単に利用することができるワークフローサービス';
const description =
  '株式会社ワークスアプリケーションズ・エンタープライズがご提供する、Workflow お問い合わせページです。';

const Contact: React.FC<ContactProps> = ({ grecaptchaKey, marketoForm }) => {
  const classes = useStyle();
  return (
    <GoogleReCaptchaProvider reCaptchaKey={grecaptchaKey}>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <SimpleMarketoForm
        header={{ from: 'workflow' }}
        heading="Workflow お問い合わせ"
        description={
          <>
            <span className={classes.lineBreaks}>
              下記フォームにご記入ください。
            </span>
            <span className={classes.lineBreaks}>
              フォーム送信後、弊社よりご案内をお送りいたします。
            </span>
          </>
        }
        marketoForm={{
          ...marketoForm,
          formName: 'workflow_contact',
        }}
      />
    </GoogleReCaptchaProvider>
  );
};

export default Contact;
